import { useTranslation } from 'react-i18next';
import './EmailMessage.scss'
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Machine } from '../../utils/models/Machine';

const EmailMessage = (props: { machine: Machine | null, token: string, onSavedText: (title: string, body: string) => void, showToastTimeOut: (msg: string, failToast: boolean) => void }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')
    const [errorTitle, setErrortitle] = useState(false)
    const [errorBody, setErrorBody] = useState(false)



    useEffect(() => {
        setTitle('')
        setBody('')
        setErrorBody(false)
        setErrortitle(false)
    }, [props.machine])

    useEffect(() => setErrortitle(false), [title])
    useEffect(() => setErrorBody(false), [body])



    return (
        <>
            <div className='emailMessageContainer text-center rounded-3'>
                <div className='d-flex justify-content-between align-items-center pt-2'>
                    <p className="mt-1 ms-3 h4 text-start flex-grow-1">{t('EmailNotification')}</p>
                    <button type='button' onClick={() => null} className="btn-Custom btn-IDBlue me-3"><i className="bi bi-send"></i></button>
                </div>
                <Form className='emailMessageForm'>
                    <div className='col'>
                        <div className='row text-start'>
                            <Form.Label className='mb-0'>{t('Title')}</Form.Label>
                            <Form.Control className={`${errorTitle ? 'is-invalid' : ''}`} maxLength={40} name="title" type="text" onChange={(e: any) => setTitle(e.target.value)} value={title} />
                        </div>
                        <div className='row text-start'>
                            <Form.Label className='mb-0'>{t('Message')}</Form.Label>
                            <Form.Control className={`${errorBody ? 'is-invalid' : ''}`} maxLength={250} name="descLang" as="textarea" onChange={(e: any) => setBody(e.target.value)} value={body} rows={3} style={{ resize: 'none' }} />
                        </div>
                    </div>
                </Form>
            </div>
        </>
    )
}

export default EmailMessage